import '../../styles/bitacora.style.css'
import { useDispatch, useSelector } from 'react-redux'
import BasicCardDocumentos from '../DatosDeCierre/BasicCardDocumentos'
import { State } from '../../../../reducers'
import { useEffect, useState } from 'react'
import { Pagination } from '../../../../components/Pagination';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

import DeleteIcon from '../../../../media/felsv/DarkRecycleDelete.svg';
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import { deleteLibroComprasDetalle } from '../../../../actions/libros/libro-compras.actions'

const TableDetalleCompras = () => {
  const {comprasLibroActivo} = useSelector((state: State) => state.libros);
  const {detalle} = comprasLibroActivo;
  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);
  const [modalConfirmDelete, setModalConfirmDelete] = useState<boolean> (false);
  const [selectedDetalle, setSelectedDetalle] = useState<any>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setSortedArray(currentItems);
  }, [currentItems]);

  const handleConfirmEliminarDetalle = (detalleLibro: any) => {
    setSelectedDetalle(detalleLibro);
    setModalConfirmDelete(true);
  }

  const handleEliminarDetalleLibro = async () => {
    if (await dispatch(deleteLibroComprasDetalle(selectedDetalle, comprasLibroActivo.libroActivo))) {
      setModalConfirmDelete(false);
    } 
  }

  return (
    <div className="w-layout-layout bill-section wf-layout-layout">
      {
        modalConfirmDelete && 
          <ModalConfirm 
            title={'Eliminar registro'} 
            detail={'Estás a punto de eliminar el registro del libro de compras. ¿Deseas continuar?'}
            closeModalConfirm={() => setModalConfirmDelete(false)} 
            actionConfirm={() => handleEliminarDetalleLibro()} 
          />
      }
      <BasicCardDocumentos 
        style={{boxShadow: 'none', padding: '0'}} 
        title="Detalle de libro" 
        size="l"
      >
        <div className="tab-plane">
          <div className="table-facturacion-resp">
            <table className="table-main-responsive responsive-table-main td-left table-pointer">
              <thead>
                <tr>
                  <td>Acciones</td>
                  <td>No. <FilterButton keyName='numcorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Fecha Emisión <FilterButton keyName='fechaemision' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Número Comprobante <FilterButton keyName='numcomprobante' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Número Registro <FilterButton keyName='numregistro' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Nombre Proveedor <FilterButton keyName='nombreproveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Locales <FilterButton keyName='exentaslocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Importaciones <FilterButton keyName='exentasimportacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Internacionales <FilterButton keyName='exentasinternacional' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Locales <FilterButton keyName='gravadaslocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Importaciones <FilterButton keyName='gravadasimportacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Internacionales <FilterButton keyName='gravadasinternacional' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Crédito Fiscal IVA <FilterButton keyName='creditofiscaliva' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Total Compras <FilterButton keyName='totalcompras' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Percepción <FilterButton keyName='percepcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Retención <FilterButton keyName='retencion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                </tr>
              </thead>
              <tbody>
                {
                  sortedArray?.length > 0 && 
                  (
                    sortedArray.map((item: any) => (
                      <tr key={item.numcorrelativo}>
                        <td data-label='Acciones' className='table-td'>
                          <Tooltip content='Eliminar Registro'>
                            <button className='table-action' onClick={(e) => handleConfirmEliminarDetalle(item)}>
                              <img src={DeleteIcon} alt='Eliminar registro' className='table-img-action' />
                            </button>
                          </Tooltip>
                        </td>
                        <td data-label='No.'>{item.numcorrelativo}</td>
                        <td data-label='Fecha Emisión'>{item.fechaemision}</td>
                        <td data-label='Número Comprobante'>{item.numcomprobante}</td>
                        <td data-label='Número Registro'>{item.numregistro}</td>
                        <td data-label='Nombre Proveedor'>{item.nombreproveedor}</td>
                        <td data-label='Exentas Locales'>{item.exentaslocales}</td>
                        <td data-label='Exentas Importaciones'>{item.exentasimportacion}</td>
                        <td data-label='Exentas Internacionales'>{item.exentasinternacional}</td>
                        <td data-label='Gravadas Locales'>{item.gravadaslocales}</td>
                        <td data-label='Gravadas Importaciones'>{item.gravadasimportacion}</td>
                        <td data-label='Gravadas Internacionales'>{item.gravadasinternacional}</td>
                        <td data-label='Crédito Fiscal IVA'>{item.creditofiscaliva}</td>
                        <td data-label='Total Compras'>{item.totalcompras}</td>
                        <td data-label='Percepción'>{item.percepcion}</td>
                        <td data-label='Retención'>{item.retencion}</td>
                      </tr>
                    ))
                  )
                }
              </tbody>
            </table>
            {detalle?.length > 0 && (
              <Pagination
                data={detalle}
                state={(items: Array<any>) => setCurrentItems(items)}
                items={20}
              />
            )}
          </div>
        </div>
      </BasicCardDocumentos>
    </div>
  )
}

export default TableDetalleCompras
